import { Link } from "react-router-dom";
import { useState } from "react";
import { api } from "../../lib/api";
import StatusBadge from "../../components/StatusBadge";
import { PageLoading, ErrorState } from "../../components/States";
import { useAdminData, act, SearchBox, FilterSelect, Pager, TableCard, TH } from "./shared";

const STATUSES = [["", "All statuses"], ["open", "Open"], ["in_progress", "In progress"], ["waiting_user", "Waiting user"], ["escalated", "Escalated"], ["resolved", "Resolved"], ["closed", "Closed"]];
const CATEGORIES = [["", "All categories"], ["booking", "Booking"], ["payment", "Payment"], ["listing", "Listing"], ["account", "Account"], ["safety", "Safety"], ["other", "Other"]];
const ROLES = [["", "All users"], ["driver", "Drivers"], ["host", "Hosts"]];

export default function AdminTickets() {
  const { data, error, page, setPage, filters, setFilters, reload } = useAdminData(api.adminTickets);
  const [q, setQ] = useState("");
  const rows = data?.items || [];

  return (
    <div data-testid="admin-tickets-page">
      <div className="flex flex-wrap gap-3 mb-4">
        <SearchBox value={q} onChange={setQ} onSearch={() => setFilters((f) => ({ ...f, q }))} placeholder="Search subject, user, ticket, booking or listing id…" testid="admin-tickets-search" />
        <FilterSelect value={filters.status || ""} onChange={(v) => setFilters((f) => ({ ...f, status: v }))} label="Status filter" testid="admin-tickets-status" options={STATUSES} />
        <FilterSelect value={filters.category || ""} onChange={(v) => setFilters((f) => ({ ...f, category: v }))} label="Category filter" testid="admin-tickets-category" options={CATEGORIES} />
        <FilterSelect value={filters.role || ""} onChange={(v) => setFilters((f) => ({ ...f, role: v }))} label="Role filter" testid="admin-tickets-role" options={ROLES} />
      </div>
      {error ? <ErrorState body={error} onRetry={reload} /> : !data ? <PageLoading label="Loading tickets…" /> : (
        <>
          <TableCard testid="admin-tickets-table" empty={rows.length === 0 && "No tickets found."}
            head={<><TH>Subject</TH><TH>User</TH><TH>Priority</TH><TH>Status</TH><TH right>Actions</TH></>}>
            {rows.map((t) => (
              <tr key={t.ticket_id} className="border-b border-[#18181B]" data-testid={`admin-ticket-${t.ticket_id}`}>
                <td className="p-4 font-semibold">
                  <Link to={`/admin/tickets/${t.ticket_id}`} data-testid={`ticket-open-${t.ticket_id}`} className="hover:text-[#FF3B45] transition-colors">
                  <span className="inline-flex items-center gap-2">{t.subject || "(no subject)"}
                    {t.source === "stripe_webhook" && (
                      <span data-testid={`ticket-stripe-badge-${t.ticket_id}`}
                            className="text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded-full bg-[#635BFF]/15 text-[#8b85ff] border border-[#635BFF]/30">Stripe</span>
                    )}
                  </span>
                  </Link>
                  <p className="text-[11px] font-normal text-zinc-600 capitalize">{t.category}</p>
                </td>
                <td className="p-4 text-xs text-zinc-400">{t.user_email}</td>
                <td className="p-4"><StatusBadge value={t.priority || "normal"} /></td>
                <td className="p-4"><StatusBadge value={t.status} /></td>
                <td className="p-4 text-right">
                  {!["resolved", "closed"].includes(t.status) && (
                    <button data-testid={`ticket-resolve-${t.ticket_id}`} onClick={() => act(() => api.adminResolveTicket(t.ticket_id), "Resolved", reload)}
                            className="text-xs font-semibold px-3 py-1.5 rounded-full border border-[#27272A] hover:border-emerald-500 text-emerald-400 transition-colors">Resolve</button>
                  )}
                </td>
              </tr>
            ))}
          </TableCard>
          <Pager page={page} total={data.total} pageSize={data.page_size} onPage={setPage} testid="admin-tickets-pager" />
        </>
      )}
    </div>
  );
}
